import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: "",
    token: null,
    infoUser: null,
    menuUser: null,
    isLoggedUserPass: false,
    isLoggedIn: false,
    isChangePass: false,
    initialMenuUser: null,
    isReplaceUser: false,
    userReplace: "",
    showUserReplace: false,
    showSuccessMessage: false,
    passwordFormMessage: "",
    moduleURL: "usuarios",
    readNotifications: {},
    tokenGenio: null,
    permissionUserGenio: null,
    infoUserReplace: {},
    temporalUsers: [],
    listTemporalUsers: [],
    tokenBusApi: null,
    isAdmin: false,
    isOtherUser: false,
    previewInfoUser: [],
    secuenceHistory: 0,
  },
  reducers: {
    signIn: (state, action) => {
      const { USRIDXXX } = action.payload.userData.data;
      state.user = USRIDXXX.toString();
      state.isLoggedUserPass = true;
    },
    signToken: (state, action) => {
      const { token } = action.payload.userData.data[0];
      const { INFOUSER } = action.payload.userData.data[0];
      const { USRIDXXX } = action.payload.userData.data[0].INFOUSER;
      state.user = USRIDXXX.toString();
      state.infoUser = INFOUSER;
      state.menuUser = INFOUSER.USERPERM;
      state.token = token;
      state.isLoggedIn = true;
      state.initialMenuUser = INFOUSER.USERPERM;
      state.showUserReplace = INFOUSER.REPLACEX;
      state.isAdmin = action.payload.userData.data[0].INFOUSER.ISADMINX === "SI" ? true : false;
      state.previewInfoUser = action.payload.userData;
    },
    signOut: (state) => {
      state.user = null;
      state.token = null;
      state.infoUser = null;
      state.menuUser = null;
      state.isLoggedUserPass = false;
      state.isLoggedIn = false;
      state.isChangePass = false;
      state.initialMenuUser = null;
      state.passwordFormMessage = "";
      state.moduleURL = "usuarios";
      state.infoUserReplace = {};
      state.isReplaceUser = false;
      state.isAdmin = false;
      state.isOtherUser = false;
      state.previewInfoUser = [];
      state.secuenceHistory = 0;
      state.permissionUserGenio = null;
    },
    changePass: (state, action) => {
      const { USRIDXXX, message } = action.payload.error.data.errors;
      state.user = USRIDXXX.toString();
      state.isChangePass = true;
      state.passwordFormMessage = message;
    },
    setMenuUser: (state, action) => {
      state.menuUser = action.payload;
    },
    setMenuUserReplace: (state, action) => {
      state.menuUser = action.payload;
      state.infoUser = { ...state.infoUser, USERPERM: action.payload };
    },
    setMenuInitialUser: (state) => {
      state.menuUser = state.initialMenuUser;
      state.infoUser = { ...state.infoUser, USERPERM: state.initialMenuUser };
    },
    setIsReplaceUser: (state, action) => {
      state.isReplaceUser = action.payload;
    },
    setUserReplace: (state, action) => {
      state.userReplace = action.payload;
    },
    showSuccessMessage: (state, action) => {
      state.showSuccessMessage = action.payload;
    },
    setModuleURL: (state, action) => {
      state.moduleURL = action.payload;
    },
    setReadNotifications: (state, action) => {
      const { id, read } = action.payload;
      state.readNotifications = { ...state.readNotifications, [id]: !read };
    },
    setReadMasiveNotifications: (state, action) => {
      state.readNotifications = action.payload;
    },
    resetNotifications: (state) => {
      state.readNotifications = {};
    },
    setTokenGenio: (state, action) => {
      state.tokenGenio = action.payload;
    },
    setPermissionUserGenio: (state, action) => {
      state.permissionUserGenio = action.payload;
    },
    setInfoUserReplace: (state, action) => {
      state.infoUserReplace = action.payload;
    },
    setTemporalUsers: (state, action) => {
      state.temporalUsers = action.payload;
      if (Object.entries(state.infoUserReplace).length === 0) {
        state.listTemporalUsers = action.payload;
      }
    },
    setListTemporalUsers: (state) => {
      let users = state.temporalUsers;
      if (Object.entries(state.infoUserReplace).length > 0) {
        //Valido que no exista la cedula del usuario actual en el listado
        const { USRIDXXX, USREMAXX, USRNOMXX } = state.infoUser;
        const exists = state.temporalUsers.filter((user) => user === USRIDXXX);
        if (exists.length === 0) {
          users = [{ USRIDTXX: USRIDXXX, USREMAXX, USRNOMXX, ORIGINAL: true }, ...users];
        }
        users = users.filter((item) => item.USRIDTXX !== state.infoUserReplace.USRIDTXX);
      }
      state.listTemporalUsers = users;
    },
    setTokenBusApi: (state, action) => {
      state.tokenBusApi = action.payload;
    },
    setChangeUser(state, action) {
      state.isOtherUser = true;
      state.secuenceHistory = action.payload.userData.data.SECINGID;
      const { token } = action.payload.userData.data[0];
      const { INFOUSER } = action.payload.userData.data[0];
      const { USRIDXXX } = action.payload.userData.data[0].INFOUSER;
      state.user = USRIDXXX.toString();
      state.infoUser = INFOUSER;
      state.menuUser = INFOUSER.USERPERM;
      state.token = token;
      state.isLoggedIn = true;
      state.initialMenuUser = INFOUSER.USERPERM;
      state.showUserReplace = false;
      state.isAdmin = action.payload.userData.data[0].INFOUSER.ISADMINX === "SI" ? true : false;
    },
    setReturnUser(state, action) {
      state.isOtherUser = false;
      const { token } = action.payload.userData.data[0];
      const { INFOUSER } = action.payload.userData.data[0];
      const { USRIDXXX } = action.payload.userData.data[0].INFOUSER;
      state.user = USRIDXXX.toString();
      state.infoUser = INFOUSER;
      state.menuUser = INFOUSER.USERPERM;
      state.token = token;
      state.isLoggedIn = true;
      state.initialMenuUser = INFOUSER.USERPERM;
      state.showUserReplace = false;
      state.isAdmin = action.payload.userData.data[0].INFOUSER.ISADMINX === "SI" ? true : false;
      state.previewInfoUser = action.payload.userData;
      state.secuenceHistory = 0;
    },
  },
});

export const {
  signIn,
  signToken,
  signOut,
  changePass,
  setMenuUser,
  setMenuUserReplace,
  setMenuInitialUser,
  setIsReplaceUser,
  setUserReplace,
  showSuccessMessage,
  setModuleURL,
  setReadNotifications,
  setReadMasiveNotifications,
  resetNotifications,
  setTokenGenio,
  setPermissionUserGenio,
  setInfoUserReplace,
  setTemporalUsers,
  setListTemporalUsers,
  setTokenBusApi,
  setChangeUser,
  setReturnUser,
} = authSlice.actions;
export default authSlice.reducer;

export const getisLoggedIn = (state) => {
  return state.persistedReducer.isLoggedIn;
};
export const getisLoggedUserPassword = (state) => {
  return state.persistedReducer.isLoggedUserPass;
};

export const getisChangePass = (state) => {
  return state.persistedReducer.isChangePass;
};

export const getUser = (state) => {
  return state.persistedReducer.user;
};

export const getDataUser = (state) => {
  return state.persistedReducer.infoUser;
};

export const getMenuUser = (state) => {
  return state.persistedReducer.menuUser;
};

export const getInitialMenuUser = (state) => {
  return state.persistedReducer.initialMenuUser;
};

export const getIsReplaceUser = (state) => {
  return state.persistedReducer.isReplaceUser;
};

export const getUserReplace = (state) => {
  return state.persistedReducer.userReplace;
};

export const getTokenUser = (state) => {
  return state.persistedReducer.token;
};

export const getShowUserReplace = (state) => {
  return state.persistedReducer.showUserReplace;
};

export const getShowSuccessMessage = (state) => {
  return state.persistedReducer.showSuccessMessage;
};

export const getPasswordFormMessage = (state) => {
  return state.persistedReducer.passwordFormMessage;
};

export const getReadNotifications = (state) => {
  return state.persistedReducer.readNotifications;
};

export const getTokenGenio = (state) => {
  return state.persistedReducer.tokenGenio;
};

export const getPermissionUserGenio = (state) => {
  return state.persistedReducer.permissionUserGenio;
};

export const getInfoUserReplace = (state) => {
  return state.persistedReducer.infoUserReplace;
};

export const getListTemporalUsers = (state) => {
  return state.persistedReducer.listTemporalUsers;
};

export const getTokenBusApi = (state) => {
  return state.persistedReducer.tokenBusApi;
};

export const getIsAdmin = (state) => {
  return state.persistedReducer.isAdmin;
};

export const getInfoUser = (state) => {
  return state.persistedReducer.infoUser;
};

export const getIsOtherUser = (state) => {
  return state.persistedReducer.isOtherUser;
};

export const getPreviewInfoUser = (state) => {
  return state.persistedReducer.previewInfoUser;
};

export const getSecuenceHistory = (state) => {
  return state.persistedReducer.secuenceHistory;
};
